import { render, staticRenderFns } from "./DeletedEditableFormatSummaryFilter.vue?vue&type=template&id=051c78c6&scoped=true&"
import script from "./DeletedEditableFormatSummaryFilter.vue?vue&type=script&lang=ts&"
export * from "./DeletedEditableFormatSummaryFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DeletedEditableFormatSummaryFilter.vue?vue&type=style&index=0&id=051c78c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c78c6",
  null
  
)

export default component.exports